// A provider model id as a person reads it (#5201) — `qwen3.8-max` → "Qwen 3.8 Max".
//
// A LABEL, never an identity: two ids may humanize alike, so nothing compares, stores
// or routes on this string. The id stays the key everywhere; this only sorts and shows.
// Total over every string — an id no rule knows still reads as itself, title-cased.

/** Ids whose plain title-casing would read wrong. Matched case-insensitively. */
const OVERRIDES: Readonly<Record<string, string>> = {
  'qwen3.8-max': 'Qwen 3.8 Max',
  k3: 'Kimi K3',
};

/** Tokens that are acronyms, not words. */
const ACRONYMS: Readonly<Record<string, string>> = {
  gpt: 'GPT',
  glm: 'GLM',
};

function word(token: string): string {
  return ACRONYMS[token.toLowerCase()] ?? token.charAt(0).toUpperCase() + token.slice(1);
}

/**
 * Humanize a model id: an override when one exists, else the last `/` segment (a
 * gateway's vendor namespace, `anthropic/…`, is the provider's business, not the
 * model's name) split on `-` / `_` and title-cased. Never throws; an id with no
 * words in it comes back unchanged.
 */
export function modelDisplayName(id: string): string {
  const override = OVERRIDES[id.toLowerCase()];
  if (override !== undefined) return override;
  const words = id
    .slice(id.lastIndexOf('/') + 1)
    .split(/[-_\s]+/)
    .filter((w) => w.length > 0);
  return words.length === 0 ? id : words.map(word).join(' ');
}
